import { ArrowForwardIosRounded } from "@mui/icons-material";
import { Stack, type StackProps } from "@mui/material";
import { type FC } from "react";

interface CustomArrowProps extends StackProps {
  arrowDirection: "back" | "forward";
}
export const CustomArrow: FC<CustomArrowProps> = (props) => {
  const { arrowDirection, ...stackProps } = props;
  return (
    <Stack
      {...stackProps}
      alignItems="center"
      justifyContent="center"
      bgcolor="#707070"
      borderRadius="40%"
      position="absolute"
      right="1rem"
      width="1.2rem"
      sx={{ cursor: "pointer", aspectRatio: 1 }}
    >
      <ArrowForwardIosRounded
        sx={{
          color: "white",
          width: "60%",
          height: "60%",
          transform:
            "rotate(" +
            (arrowDirection === "forward" ? "180deg" : "0deg") +
            ")",
        }}
      />
    </Stack>
  );
};
